module.exports = __webpack_public_path__ + "media/couple-testimonial-03.7ed4cd76.png";